import { connect } from 'react-redux'
import UI from './UI'
import { push } from 'connected-react-router'
import { showPopUp, addToFavorite, removeFromFavorite, changeFollowStateAction } from 'pages/Course/store'
import { AddItemToCartAction } from 'components/Cart/store'
import { decorateUrl } from 'components/common/UTMscript'

const mapStateToProps = ({ user, identity, course, support, referential }) => ({
  isConnected: identity.isConnected,
  ProfileType: referential?.ProfileTypes ? referential?.ProfileTypes[user?.ProfileType] : null,
  Id: course.Course.Id,
  Title: course.Course.Title,
  Subtitle: course.Course.Subtitle,
  Image: course.Course.Image,
  MobileImageUrl: course.Course.MobileImageUrl,
  AuthorFirstName: course.Course.Author.FirstName,
  AuthorLastName: course.Course.Author.LastName,
  AuthorPhoto: course.Course.Author.Photo,
  AuthorId: course.Course.AuthorSlug,
  Rating: course.Course.Rating,
  ViewersCount: course.Course.ViewersCount,
  ReviewersCount: course.Course.ReviewersCount,
  Price: course.Course.Price,
  NewPrice: course.Course.NewPrice,
  HasActivePromotion: course.Course.HasActivePromotion,
  DiscountPrice: course.Course.DiscountPrice,
  DiscountPercentage: course.Course.DiscountPercentage,
  Duration: course.Course.Duration,
  CurrencyId: referential && referential.Currencies ? referential.Currencies[support.CurrencyId] : '',
  franceShop: referential.IsFrance,
  Slug: course.Course.Slug,
  IsFavorite: course.Course.IsFavorite,
  IsAccessible: course?.Course?.IsAccessible,
  AlternativePrice: course.Course.AlternativePrice,
  PricePromo: course.Course.PricePromo,
  AlternativePricePromo: course.Course.AlternativePricePromo,
  loading: course.gettingCoursesInfos
})

const mapDispatchToProps = dispatch => ({
  goToTrainer: url => dispatch(push(decorateUrl(url))),
  addToCart: course => dispatch(AddItemToCartAction(course)),
  showPopUp: state => dispatch(showPopUp(state)),
  addToFavorite: _ => dispatch(addToFavorite()),
  removeFromFavorite: _ => dispatch(removeFromFavorite()),
  changeFollowState: _ => dispatch(changeFollowStateAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
